/**
 * The small status badge used across the legacy Bexio page and the mapping
 * modals. Moved verbatim out of `AdminBexioPage` (UI-4b); both sides now import
 * it rather than the page owning a copy the modals could drift from.
 */
import React from "react";

export default function Badge({ children, tone = "neutral" }) {
  const tones = {
    neutral: "border-input text-muted-foreground",
    good: "border-emerald-200 dark:border-emerald-500/30 text-emerald-700 dark:text-emerald-400",
    warn: "border-amber-200 dark:border-amber-500/30 text-amber-800 dark:text-amber-300",
    bad: "border-red-200 dark:border-red-500/30 text-red-700 dark:text-red-300",
  };
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.05em] ${
        tones[tone] || tones.neutral
      }`}
    >
      {children}
    </span>
  );
}
